import React from 'react';
import { Tooltip, IconButton, Box, Typography, Stack } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { keyframes } from '@mui/system';

const flash = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.2; }
  100% { opacity: 1; }
`;

interface AlarmStatusProps {
    alarms?: string[] | null;
}

const AlarmStatus: React.FC<AlarmStatusProps> = ({ alarms }) => {
    if (!alarms || alarms.length === 0) {
        return null;
    }

    const alarmList = (
        <Box sx={{ p: 1 }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                Active Alarms
            </Typography>
            <Stack spacing={0.5}>
                {alarms.map((alarm, index) => (
                    <Typography key={index} variant="body2">
                        • {alarm}
                    </Typography>
                ))}
            </Stack>
        </Box>
    );

    return (
        <Tooltip title={alarmList} arrow placement="top">
            <IconButton 
                size="small" 
                color="error"
                sx={{ 
                    animation: `${flash} 2s infinite ease-in-out` 
                }}
            >
                <WarningIcon />
            </IconButton>
        </Tooltip>
    );
};

export default AlarmStatus;
